export const SENSITIVE_KEYS = new Set([
  'accessToken',
  'accessTokens',
  'anonymousApiKey',
  'apiKey',
  'apiKeyId',
  'apiKeys',
  'jwk',
  'password',
  'secretApiKey',
  'secretValue',
  'token',
]);

export const SENSITIVE_URL_PARAMS = new Set(['jwt', 'apiKey', 'token', 'code']);

export const REDACTED = '[REDACTED]';

/**
 * Parses a JSON string, redacts any top-level keys that match SENSITIVE_KEYS,
 * and returns the re-serialized string. Returns the original if nothing was
 * redacted. Returns REDACTED if the JSON is malformed.
 */
export function redactJsonField(raw: string | undefined): string | undefined {
  if (!raw) {
    return raw;
  }
  try {
    const parsed = JSON.parse(raw);
    let changed = false;
    for (const key of Object.keys(parsed)) {
      if (SENSITIVE_KEYS.has(key)) {
        parsed[key] = REDACTED;
        changed = true;
      }
    }
    return changed ? JSON.stringify(parsed) : raw;
  } catch {
    return REDACTED;
  }
}

/**
 * Like redactJsonField but targets `.variables` inside a JSON payload
 * (the shape sent by GraphQL clients: `{query, variables}`).
 * Non-JSON payloads (raw query strings) are returned unchanged.
 */
export function redactPayloadField(
  raw: string | undefined
): string | undefined {
  if (!raw) {
    return raw;
  }
  try {
    const parsed = JSON.parse(raw);
    if (!parsed.variables) {
      return raw;
    }
    let changed = false;
    for (const key of Object.keys(parsed.variables)) {
      if (SENSITIVE_KEYS.has(key)) {
        parsed.variables[key] = REDACTED;
        changed = true;
      }
    }
    return changed ? JSON.stringify(parsed) : raw;
  } catch {
    return raw;
  }
}
